<template>
  <div class="w-1000px">
    <Loading :text="msg" :loading="loading"/>
    <div class="p-10px" style="max-height: 70vh;overflow-y: auto">
      <div v-for="(voucher, index) in voucherList" :key="index" class="margin-bottom">
        <div class="font-bold text-center margin-bottom">凭证预览：{{ voucher.orderCode }}</div>
        <Table :datas="voucher.lines" :border="true">
          <TableItem title="摘要" prop="summary"></TableItem>
          <TableItem title="科目" prop="subjectName"></TableItem>
          <TableItem title="借方金额" align="right">
            <template slot-scope="{data}">{{ money(data.jie) }}</template>
          </TableItem>
          <TableItem title="贷方金额" align="right">
            <template slot-scope="{data}">{{ money(data.dai) }}</template>
          </TableItem>
        </Table>
        <div class="text-right margin-top" :class="{'red-color': !balanced(voucher)}">
          合计　借方：{{ total(voucher, 'jie') }}　贷方：{{ total(voucher, 'dai') }}
          <template v-if="!balanced(voucher)">（借贷不平！）</template>
        </div>
      </div>
      <div v-if="!loading && voucherList.length === 0" class="text-center padding">
        没有可生成凭证的数据
      </div>
    </div>
    <div class="h-modal-footer">
      <Button :loading="loading" @click="$emit('close')" icon="fa fa-close">取消</Button>
      <Button :disabled="can" :loading="loading" @click="doGenerate" color="primary" icon="fa fa-save">
        确认生成{{ voucherList.length }}张凭证
      </Button>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2020 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : financial</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022/6/16 14:22</li>
 * <li>@author     : ____′↘TangSheng</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "JXCGenerateVoucherPreview",
  props: {
    type: Number,
    records: Array,
  },
  data() {
    return {
      loading: false,
      voucherList: [],
      msg: '正在获取预览数据~'
    }
  },
  computed: {
    can() {
      return this.loading || this.voucherList.length === 0 || this.voucherList.some(voucher => !this.balanced(voucher));
    }
  },
  methods: {
    money(val) {
      return Number(val || 0).toFixed(2);
    },
    total(voucher, field) {
      let total = 0;
      (voucher.lines || []).forEach(line => {
        total += Number(line[field] || 0);
      });
      return total.toFixed(2);
    },
    balanced(voucher) {
      return this.total(voucher, 'jie') === this.total(voucher, 'dai');
    },
    init() {
      this.loading = true;
      this.$api.setting.inventoryOrder.preview(this.records.map(r => r.id)).then(({data}) => {
        this.voucherList = data || [];
      }).finally(() => this.loading = false);
    },
    doGenerate() {
      this.loading = true;
      this.$api.setting.inventoryOrder.generate(this.records.map(r => r.id)).then(() => {
        this.$Message('凭证生成成功');
        //通知父组件刷新列表（HeyUI 内置绑定 close 事件用于关闭弹窗，自定义 close 监听会被屏蔽，须用独立事件名）
        this.$emit('success');
        this.$emit('close');
      }).finally(() => this.loading = false);
    }
  },
  created() {
    this.init();
  }
}
</script>

<style scoped>

</style>
